"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LTImageTagViews = void 0;
var React = require("react");
var styles = require("./index.scss");
exports.LTImageTagViews = function (props) {
    var columnNum = props.columnNum, rightTopTag = props.rightTopTag, leftTopTag = props.leftTopTag, leftBottomTag = props.leftBottomTag;
    return (React.createElement("div", { className: styles["LTImageTagViews_" + columnNum] },
        rightTopTag && React.createElement("img", { className: styles.rightTopTag, src: rightTopTag }),
        leftTopTag && React.createElement("img", { className: styles.leftTopTag, src: leftTopTag }),
        leftBottomTag && React.createElement("img", { className: styles.leftBottomTag, src: leftBottomTag })));
};
